import React from 'react'
import cz from 'classnames'
import { Modal, Icon } from 'antd-mobile'
import { ModalPropsType } from 'antd-mobile/es/modal/PropsType'
import styles from './style.module.scss'

interface FullModalProps extends ModalPropsType<any> {
  style?: React.CSSProperties
  isList?: boolean
}

const FullModal: React.FC<FullModalProps> = (props) => {
  const { style, isList = true, title, children, onClose, ...rest } = props

  return (
    <Modal
      title={
        <div className={styles.header}>
          <b>{title}</b>
          <Icon
            type="cross"
            size="md"
            className={styles.btn}
            onClick={onClose}
          />
        </div>
      }
      wrapClassName={cz(styles.wrap, {
        [styles.border]: !isList,
      })}
      animationType="slide-up"
      popup
      {...rest}
    >
      <div
        style={style}
        className={cz(styles.content, {
          [styles.normal]: !isList,
        })}
      >
        {children}
      </div>
    </Modal>
  )
}

export default FullModal
